import { ConfigProvider } from 'antd';
import azAZ from 'antd/locale/az_AZ';
import ruRU from 'antd/locale/ru_RU';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/** Встроенные тексты antd (пагинация, «Отмена», календарь) — на языке интерфейса. */
export function LocalizedAntd({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  return (
    <ConfigProvider locale={i18n.language === 'az' ? azAZ : ruRU} componentSize="small">
      {children}
    </ConfigProvider>
  );
}
